import { useState } from 'react'
import { IosLoader } from '../components/Loaders/IosLaoder/IosLoader'

export const StatusPage = () => {
    const [isLoading, setIsLoading] = useState(true)

    return (
        <div style={{ position: 'relative', width: '100%', height: '100%'}}>
            {isLoading && (
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <IosLoader />
                </div>
            )}
            <iframe
                src="https://combot-status.deguard.io/"
                width="100%"
                height="100%"
                title="Example Iframe"
                style={{ border: 'none' }}
                onLoad={() => setIsLoading(false)}
            />
        </div>
    )
}
